import React from "react";
import styled from "styled-components";

import { Link } from "gatsby";
import { CheckCircle } from "react-feather";
import { groupServiceAreasByRegion } from "../data/city-coordinates";

const AreasServedContainer = styled.div`
  h1 {
    font-size: calc(0.75vw + 1.5em);
  }
`;

function parseContent(string, altCity) {
  if (string) {
    return string.replace(/San Jose/g, altCity);
  }
}

export const AreasServed = (props) => {
  const { citiesList, className, serviceName = "", parentPageSlug, blogComponent } = props;

  const getServiceTitle = () => {
    if (serviceName.includes("Residential Remodeling Contractor")) return "Residential Roofing";
    if (serviceName.includes("Remodeling Outlet & Switches Installation"))
      return "Remodeling Outlet & Switches Services";
    if (serviceName.includes("Remodeling Panel")) return "Remodeling Panel Services";
  };

  const getServiceSlug = () => {
    if (serviceName.includes("Full Home Remodeling")) return "whole-house-remodeling";
    if (serviceName.includes("Kitchen Remodeling")) return "kitchen-remodeling";
    if (serviceName.includes("Bathroom Remodeling")) return "bathroom-remodeling";
    if (serviceName.includes("Roofing Contractor")) return "roofing";
  };

  const serviceTitle = getServiceTitle();
  const serviceSlug = getServiceSlug();

  return (
    <AreasServedContainer className="flex flex-wrap  px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="container is-service-page">
        <div className="pt-8 pb-5">
          {!blogComponent ? (
            <div className="pt-10 pb-5 bg-white rounded-2xl">
              <h2 className="px-8 text-2xl font-bold text-neutral-900 font-display">Areas We Serve</h2>
              {groupServiceAreasByRegion(citiesList).map((region) => (
                <div key={region.name} className="px-8 pt-6">
                  <h3 className="text-lg font-bold text-neutral-900 font-display">{region.name}</h3>
                  <ul className="flex flex-wrap list-none p-0 m-0">
                    {region.cities.map((item) => {
                      const location = item.node.location.trim();
                      return (
                        <li key={item.node.slug} className="w-1/2 md:w-1/3 flex space-y-4 md:space-y-6">
                          <div className="flex-shrink-0 mr-2">
                            <CheckCircle fontWeight={900} strokeWidth={3} size={20} className="text-brand-500 mt-2" />
                          </div>{" "}
                          <Link
                            style={{ marginTop: 0, textDecoration: "none" }}
                            className="text-neutral-800 underline-none"
                            title={`${serviceName} in ${location}, MI`}
                            to={`/${serviceSlug}-${item.node.slug}/`}
                          >
                            {location}
                            <span className="block text-sm font-normal text-neutral-500">
                              {parseContent(serviceName, location)}
                            </span>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ))}
            </div>
          ) : (
            <ul className="flex flex-wrap list-none m-0">
              {citiesList.map((item, i) => (
                <li key={i} className="w-1/2 md:w-1/4 flex">
                  <div className="flex-shrink-0 pr-1">
                    <svg className="h-6 w-6 text-brand-500" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>{" "}
                  <Link
                    className="text-neutral-800 hover:text-brand-600"
                    title={`${item.location + " " + (serviceTitle ? serviceTitle : "")}`}
                    to={`/${serviceSlug ? serviceSlug : ""}-${item.slug + "/"}`}
                  >
                    {item.location}
                  </Link>
                </li>
              ))}
              sfsf
              {citiesList.map((item, i) => (
                <li key={i} className="w-1/2 md:w-1/4 flex">
                  <div className="flex-shrink-0 pr-1">
                    <svg className="h-6 w-6 text-brand-500" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>{" "}
                  <Link
                    className="text-neutral-800 hover:text-neutral-800"
                    title={`${"Roofing " + item.location + ", MI"}`}
                    to={`/areas-we-serve/${item.slug}/`}
                  >
                    {item.location}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </AreasServedContainer>
  );
};
